module.exports = __webpack_public_path__ + "img/main_hsw.050b4c61.jpg";